export const getSiteName = () => {
  const appName = process.env.REACT_APP_SITE_NAME || 'PHARMA'
  const healthtechRegex = /^healthtech$/i
  const reportsRegex = /^reports$/i
  const fwReportsRegex = /^fwreports$/i

  if (healthtechRegex.test(appName)) {
    return 'HealthTech'
  }
  if (reportsRegex.test(appName)) {
    return 'Reports'
  }

  if (fwReportsRegex.test(appName)) {
    return 'Reports'
  }

  return 'Pharma'
}

export const allSubscriptionTypes = {
  HealthTech: {
    PLUS: 'FirstWord HealthTech PLUS',
    FREE: 'FirstWord HealthTech'
  },
  Reports: {
    PLUS: 'FirstWord Reports Premium',
    FREE: 'FirstWord Reports'
  },
  Pharma: {
    PLUS: 'FirstWord Pharma PLUS',
    FREE: 'FirstWord Pharma'
  }
}

export const getSubscriptionTypes = () => {
  return allSubscriptionTypes[siteName]
}

export const getFreeSubscriptionTypes = () => {
  return Object.keys(allSubscriptionTypes).map(
    subscription => allSubscriptionTypes[subscription]?.FREE
  )
}

export const getPlusSubscriptionTypes = () => {
  return Object.keys(allSubscriptionTypes).map(
    subscription => subscriptions[subscription]?.PLUS
  )
}

export const getSiteDomain = () => {
  switch (siteName) {
    case 'HealthTech':
      return 'firstwordhealthtech.com'

    case 'Reports':
      return 'firstwordreports.com'

    default:
      return 'firstwordpharma.com'
  }
}

export const getOtherSitesDomains = () => {
  if (siteName === 'HealthTech') {
    return ['firstwordreports.com', 'firstwordpharma.com']
  } else {
    return ['firstwordreports.com', 'firstwordhealthtech.com']
  }
}

const getSocialMedialInfo = () => {
  if (siteName === 'HealthTech') {
    return {
      twitter: '@fwhealthtech',
      linkedin: 'firstwordhealthtech.com'
    }
  } else {
    return {
      twitter: '@fwpharma',
      linkedin: 'firstwordpharma.com'
    }
  }
}

const getSiteStoryViews = () => {
  if (siteName === 'Reports') {
    return {
      relatedNews: 'related news'
    }
  }

  return {
    recentNews: 'recent news',
    relatedAnalysis: 'related analysis',
    relatedNews: 'related news'
  }
}

export const siteName = getSiteName()
export const siteDomain = getSiteDomain()
export const socialMediaInfo = getSocialMedialInfo()
export const otherSitesDomains = getOtherSitesDomains()
export const siteStoryViews = getSiteStoryViews()
